var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_lock",
    "data-name": "Icon / lock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.25,
    height: 14,
    viewBox: "0 0 12.25 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "lock",
    d: "M10.937,6.124H10.5V4.415a4.375,4.375,0,1,0-8.75-.041v1.75H1.312A1.313,1.313,0,0,0,0,7.437v5.25A1.313,1.313,0,0,0,1.312,14h9.625a1.313,1.313,0,0,0,1.312-1.312V7.437A1.313,1.313,0,0,0,10.937,6.124ZM2.625,4.374a3.5,3.5,0,0,1,7,0v1.75h-7Zm8.312,8.75H1.312a.439.439,0,0,1-.437-.437V7.437A.439.439,0,0,1,1.312,7h9.625a.439.439,0,0,1,.438.437v5.25A.439.439,0,0,1,10.937,13.124Z",
    transform: "translate(0 0.001)",
    fill: "#1a1a1a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lock.bac3a2275ee4cf20e1213320da0aff19.svg";